export const getCookieValue = (key: string): string | null => {
  const equalities = document.cookie.split("; ");
  for (const equality of equalities) {
    if (!equality) {
      continue;
    }

    const splitted = equality.split("=");
    if (splitted.length != 2) {
      continue;
    }

    if (decodeURIComponent(splitted[0]) === key) {
      return decodeURIComponent(splitted[1] || "");
    }
  }

  return null;
};
